import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

const errorReportingEnv = process.env.WIZ_ENV;
const errorReportingDsn = process.env.ERROR_REPORTING_DSN;

export function initSentry(version?: string) {
  if (errorReportingEnv == undefined
    || errorReportingDsn == undefined) {
    return;
  }
  const checkedVersion = (version != undefined
    && version != '<SENTRY_VERSION_TO_REPLACE>')
    ? version
    : undefined;
  Sentry.init({
    dsn: errorReportingDsn,
    environment: errorReportingEnv,
    release: checkedVersion,
    integrations: [new Integrations.Vue({
      Vue,
      attachProps: true,
      logErrors: true,
    })],
  });
}

export function configureSentryScopeTags(homeId?: number, macAddress?: string) {
  if (errorReportingEnv == undefined
    || errorReportingDsn == undefined) {
    return;
  }
  Sentry.configureScope((scope) => {
    scope.clear();
    if (homeId != undefined) {
      scope.setTag('homeId', String(homeId));
    }
    if (macAddress != undefined) {
      scope.setTag('macAddress', macAddress);
    }
  });
}




// WEBPACK FOOTER //
// ./src/helpers/sentryManager.ts